import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/analytics';
import firebaseProdConfig from './firebase_config/firebase.production.config.json';
import firebaseStagConfig from './firebase_config/firebase.staging.config.json';

// Initialize Firebase for production
const firebaseConfig = process.env.REACT_APP_ENV === 'staging' ? firebaseStagConfig : firebaseProdConfig;
const firebaseAppProd = firebase.initializeApp(firebaseConfig, 'production');
export const auth = firebaseAppProd.auth();
export const db = firebaseAppProd.firestore();

export const authReady: Promise<firebase.User | null> = new Promise((resolve) => {
  const unsubscribe = auth.onAuthStateChanged((user) => {
    unsubscribe();
    if (user) {
      resolve(user);
    } else {
      auth
        .signInAnonymously()
        .then((credential) => resolve(credential.user))
        .catch((error) => {
          console.error('Anonymous sign-in failed:', error);
          resolve(null);
        });
    }
  });
});

export const storage = firebaseAppProd.storage();
export const analytics = firebaseAppProd.analytics && firebaseAppProd.analytics();

// Export Firebase instances
export { firebaseAppProd };
